import * as Types from '../../../modules/decisionsNext/api/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'utils/apolloWrapper';
const defaultOptions = {} as const;
export type CountPoliciesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.PolicyFilter>;
}>;


export type CountPoliciesQuery = { __typename?: 'Query', aggregatePolicy: { __typename?: 'AggregatedPolicy', metric: number } };


export const CountPoliciesDocument = gql`
    query CountPolicies($filter: PolicyFilter) {
  aggregatePolicy(filter: $filter) {
    metric(metric: POLICY_COUNT)
  }
}
    `;

/**
 * __useCountPoliciesQuery__
 *
 * To run a query within a React component, call `useCountPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPoliciesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCountPoliciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CountPoliciesQuery, CountPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CountPoliciesQuery, CountPoliciesQueryVariables>(CountPoliciesDocument, options);
      }
export function useCountPoliciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CountPoliciesQuery, CountPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CountPoliciesQuery, CountPoliciesQueryVariables>(CountPoliciesDocument, options);
        }
// @ts-ignore
export function useCountPoliciesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CountPoliciesQuery, CountPoliciesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CountPoliciesQuery, CountPoliciesQueryVariables>;
export function useCountPoliciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CountPoliciesQuery, CountPoliciesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CountPoliciesQuery | undefined, CountPoliciesQueryVariables>;
export function useCountPoliciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CountPoliciesQuery, CountPoliciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CountPoliciesQuery, CountPoliciesQueryVariables>(CountPoliciesDocument, options);
        }
export type CountPoliciesQueryHookResult = ReturnType<typeof useCountPoliciesQuery>;
export type CountPoliciesLazyQueryHookResult = ReturnType<typeof useCountPoliciesLazyQuery>;
export type CountPoliciesSuspenseQueryHookResult = ReturnType<typeof useCountPoliciesSuspenseQuery>;
export type CountPoliciesQueryResult = Apollo.QueryResult<CountPoliciesQuery, CountPoliciesQueryVariables>;